module.exports = __webpack_public_path__ + "img/arrow_down.c63c4f45.svg";